export class ConfiguracionDTO{

	 /**Parametro que permite habilitar Mensaje Juramento Resumen de Respuesta */
	 public menJurRes: string;

	 /**Parametro que permite habilitar Mensaje Contexto Resumen de Respuesta */
	 public menResRes: string;
	 

    constructor(   
	
	/** Hace referencia al tipo de prueba que se realizará	 */    
	public typeTest: string,	

	/** Hace referencia al tipo de tour que se mostrará	 */    
	public tourTest: string,	
		
	/** Hace referencia a la opción de revisar Exámen	 */
	public reviewTest: Boolean,
	
	/** Hace referencia a la opción de botón atras en el Examen	 */
	public backButton: Boolean,
	
	/**Hace referencia a la opcion de conteo de preguntas del Examen*/
	public counter: Boolean,
	
	/** Hace referencia a la opción de ver Resumen del Examen	 */
	public summaryTest: Boolean,
	
	/** Hace referencia a la opcion de enviar correo en el Examen	 */
	public sendMail: Boolean,
	
	/** Hace referencia al lenguaje del Examen	 */
	public language: string = "es",
	
	/** Opción que permite una única sesión por usuario */
	public singleSession: Boolean,

	/** Opcion que permite activar el cronometro en una prueba */
	public chrono: Boolean,

	/** Opcion que permite activar la opcion descargar respuestas en una prueba*/
	public downloadAnswer: Boolean,
	
	/** Opcion que permite activar la opcion cambiar nombre cronometro en una prueba*/
	public changeName: Boolean,

	/** Permite volver al welcome apra iniciar una neuva sesion */
	public multiplesesion: Boolean,

	/** Permite activar la simulacion del examen */
	public showSimulation: Boolean,

	/** Permite mostrar los terminos y condiciones */
	public showTerms: string,

	/** Permite inhabilitar la visualización de la bienvenida, toour y confirmación de datos */
	public hideWelcome: Boolean,

	/** Permite mostrar el resultado de una prueba adaptativa */
	public showScore: Boolean,
	
	/** Permite seleccionar el texto del item */
	public highligthText: Boolean,
	
	/** Permite mostrar las notas */
	public quickNotes: Boolean,
	
	/** Permite activar el zoom de las imagenes */
	public zoomImage: Boolean = true,

	/** Permite activar el chat */
	public conChat: Boolean,

	/** Permite activar el calculadora */
	public calculator: Boolean,

	/** Permite activar seguridad con territorium */
	public securityterri: Boolean,

	/** Permite activar seguridad con territorium */
	public securitySumadi: Boolean,

	/** Permite mostrar la opcion del pdf */
	public showPdf: Boolean,
	
	/**Permite mostrar el mensaje inicial de pregunta abierta*/
	public msjInicialrtaAbierta: String = "", 
	
	/**Permite mostrar el mensaje final de pregunta abierta*/
	public msjFinalrtaAbierta: String =  "",

	/**Permite mostrar el mensaje para el limite minimo de caracteres de Pregunta abierta*/
	public msjCaracteresPA: String =  "",
	
	/**Permite validar el tamaño minimo de caracteres para pregunta abierta*/
	public cantidadCaracteresPA: number = 0,

	/**Permite establecer el tiempo de autoguardado de la respuesta en una prueba con pregunta abierta*/
	public autoSavePreguntaAbierta: number = 60000, //default 1 minuto

	/**Codigo de la apliacion*/
	public apliId: string = "",

	/**Parámetro que permite mostrar un componente html en la aplicación*/
	public html: string = null,
	
	/** Parámetro que permite habilitar certificado de asistencia */
	public downloadCertificado: Boolean = false

	){
        
	}
	
}